import RemoteDetail from './RemoteDetail.vue';
import RemoteDetailActivity from './detail/RemoteDetailActivity.vue';
import RemoteDetailConfiguration from './detail/RemoteDetailConfiguration.vue';
import RemoteDetailDevices from './detail/RemoteDetailDevices.vue';
import RemoteDetailGroups from './detail/RemoteDetailGroups.vue';
import RemoteDetailMetrics from './detail/RemoteDetailMetrics.vue';
import RemoteDetailNetwork from './detail/RemoteDetailNetwork.vue';
import RemoteDetailOverview from './detail/RemoteDetailOverview.vue';
import RemoteDetailReplay from './detail/RemoteDetailReplay.vue';
import RemoteDetailSubscription from './detail/RemoteDetailSubscription.vue';
import RemoteDetailSupport from './detail/RemoteDetailSupport.vue';
import RemoteDetailUsage from './detail/RemoteDetailUsage.vue';

import RemoteCreate from './create/RemoteCreate.vue';
import OptionFileValidator from './detail/RemoteDetailOptionFileValidator.vue'

export default function RemoteRoutes() {
  return [
    {
      path: ':id',
      component: RemoteDetail,
      children: [
        {
          path: 'activity',
          component: RemoteDetailActivity,
          name: 'remoteActivity'
        },
        {
          path: 'configuration',
          component: RemoteDetailConfiguration,
          name: 'remoteConfiguration'
        },
        {
          path: 'devices',
          component: RemoteDetailDevices,
          name: 'remoteDevices'
        },
        {
          path: 'groups',
          component: RemoteDetailGroups,
          name: 'remoteGroups'
        },
        {
          path: 'metrics',
          component: RemoteDetailMetrics,
          name: 'remoteMetrics'
        },
        {
          path: 'network',
          component: RemoteDetailNetwork,
          name: 'remoteNetwork'
        },
        {
          path: 'overview',
          component: RemoteDetailOverview,
          name: 'remoteOverview'
        },
        {
          path: 'replay',
          component: RemoteDetailReplay,
          name: 'remoteReplay'
        },
        {
          path: 'subscription',
          component: RemoteDetailSubscription,
          name: 'remoteSubscription'
        },
        {
          path: 'support',
          component: RemoteDetailSupport,
          name: 'remoteSupport'
        },
        {
          path: 'usage',
          component: RemoteDetailUsage,
          name: 'remoteUsage'
        }
      ]
    },
    {
      path: 'create',
      component: RemoteCreate,
      name: 'remoteCreate',
      meta: {
        detail: true
      }
    },
    {
      path: 'optionFileValidator',
      component: OptionFileValidator,
      name: 'optionFileValidator',
      meta: {
        detail: true
      }
    }
  ]
}
